import axios from '../../../services/axios'

import * as actionTypes from '../actionTypes';
import {setMessage} from "../message";

export const loadCertificateRequests = () => {
    return {
        type: actionTypes.LOAD_CERTIFICATE_REQUESTS
    }
}

export const setCertificateRequests = (certificateRequests) => {
    return {
        type: actionTypes.SET_CERTIFICATE_REQUESTS,
        certificateRequests: certificateRequests
    }
}

export const getCertificateRequests = () => {
    return (dispatch) => {
        dispatch(loadCertificateRequests())
        axios.get( `/api/v1/certificate`)
            .then( response => {
                dispatch( setCertificateRequests(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const loadCertificatePlaces = () => {
    return {
        type: actionTypes.LOAD_CERTIFICATE_PLACES
    }
}

export const setCertificatePlaces = (certificatePlaces) => {
    return {
        type: actionTypes.SET_CERTIFICATE_PLACES,
        certificatePlaces: certificatePlaces
    }
}

export const getCertificatePlaces = () => {
    return (dispatch) => {
        dispatch(loadCertificatePlaces())
        axios.get( `/api/v1/certificate/places`  )
            .then( response => {
                dispatch( setCertificatePlaces(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const sendCertificateRequest = () => {
    return {
        type: actionTypes.SEND_CERTIFICATE_REQUEST
    }
}

export const receiveSendCertificateRequestResult = (result) => {
    return {
        type: actionTypes.RECEIVE_SEND_CERTIFICATE_REQUEST_RESULT,
        newCertificateRequest: result
    }
}

export const postCertificateRequest = (dto) => {
    return (dispatch) => {
        dispatch(sendCertificateRequest())
        axios.post( `/api/v1/certificate/register`, dto)
            .then(response => {
                if(response.data.length === 1) {
                    dispatch(setMessage({type: 'success', text: "Справка успешно заказана."}))
                    dispatch(receiveSendCertificateRequestResult(response.data[0]));
                } else {
                    response.data.forEach((data) => {
                        dispatch(receiveSendCertificateRequestResult(data));
                    })
                    dispatch(setMessage({type: 'success', text: "Справки успешно заказаны."}))
                }
            })
            .catch(_error => {
                dispatch(setMessage({type: 'error', text: "Не удалось заказать справку."}))
            });
    }
}

////////////////////////////////////////////////////////////////

export const updateCertificateRequest = (certificateRequest) => {
    return {
        type: actionTypes.UPDATE_CERTIFICATE_REQUEST,
        certificateRequest: certificateRequest
    }
}

export const closeCertificateRequestById = (id) => {
    return (dispatch) => {
        axios.get( `/api/v1/certificate/close?id=${id}`)
            .then( response => {
                dispatch(setMessage({type: 'success', text: "Справка успешно отменена."}))
                dispatch(updateCertificateRequest(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось отменить справку."}))
            } );
    }
}